import { AxiosError, AxiosRequestConfig } from 'axios';

import { ToastHelper } from 'helpers/ToastHelper';
import isNetworkErrorValidation from 'utils/methods/isNetworkErrorValidation';

// Interface para definir a estrutura do objeto de retorno do método _exception.
interface ExceptionResult {
  error: string;
  isNetworkError: boolean;
}

export class GenericAPI {
  /**
   * Manipula exceções de API, exibindo uma notificação e retornando um objeto de erro padronizado.
   * @param e O erro capturado (geralmente de uma chamada de API).
   * @param message A mensagem de fallback a ser exibida se não for um erro de rede.
   * @returns Um objeto contendo a mensagem de erro e um booleano indicando se foi erro de rede.
   */
  static _exception(e: any, _message: string): ExceptionResult {
    const isNetworkError: boolean = isNetworkErrorValidation(e);
    const message: string = isNetworkError ? 'Sem internet, entre em contato com a administração do Locker' : _message;

    if (isNetworkError) {
      ToastHelper.dismissable({ message });
    } else {
      ToastHelper.error({ message })
    }

    return { error: message, isNetworkError };
  }
}


const NUMBER_OF_TRIES: number = 3;

/**
 * Interface para tipar o objeto de configuração do axios-retry.
 */
interface AxiosRetryConfig {
  retries: number;
  retryDelay: (retryCount: number) => number;
  retryCondition: (error: AxiosError) => boolean;
  onRetry: (retryCount: number, error: AxiosError, requestConfig: AxiosRequestConfig) => void;
}

/**
 * Configuração para a biblioteca axios-retry
 */
export const axiosRetryConfig: AxiosRetryConfig = {
  retries: NUMBER_OF_TRIES,

  retryDelay: (retryCount: number): number => {
    return retryCount * 10000;
  },

  retryCondition: isNetworkErrorValidation,

  onRetry: (retryCount, error, requestConfig) => {
    console.log(`Retry count: ${retryCount} - URL: ${requestConfig.url}`);
    ToastHelper.error({
      message: `Sem internet. Realizando nova tentativa de conexão: ${retryCount} de ${NUMBER_OF_TRIES}`,
      duration: retryCount * 10000,
    });
  }
};